import React from 'react'
import ActivateSubAdminWidget from '../../../Auth/sub_admin/subadmin_activate_invite'
import {Switch, Route } from 'react-router-dom'; // Change here
import SubadminInnvite from '../../../Auth/sub_admin/subadmin_invite';

function SubAdmin({match}) {
  return (
    <div>
        <Switch>
            <Route path={`${match.path}/`} exact component={SubAdminHome} />
            <Route path={`${match.path}/activate-account/:id`} component={ActivateSubAdminWidget} />
            <Route path={`${match.path}/invitation/:id`} component={SubadminInnvite} />
        </Switch>
    </div>
  )
}

export default SubAdmin




function SubAdminHome() {
  return (
    <div>sub-admin</div>
  )
}
